/**
 * Shared Security Badge Component for Checkout Pages
 * Displays security and trust information
 */

import React from 'react';
import { Shield } from 'lucide-react';

export const CheckoutSecurityBadge: React.FC = () => {
  return (
    <div className="bg-white/90 dark:bg-kind-graphite/90 backdrop-blur-sm rounded-2xl p-6 border border-gray-200 dark:border-white/10">
      <div className="flex items-center space-x-3 mb-4">
        <Shield className="h-5 w-5 text-kind-text-secondary" />
        <h3 className="font-semibold text-kind-text-primary">Secure & Trusted</h3>
      </div>
      <div className="space-y-2 text-sm text-kind-text-secondary">
        <p>• Powered by Stripe for secure payments</p>
        <p>• Cancel anytime from your account</p>
        <p>• 30-day money-back guarantee</p>
        <p>• Your data is always protected</p>
      </div>
    </div>
  );
};
